module.exports = __webpack_public_path__ + "img/hakunamakiki.5a8ee89b.png";